import AnalysisKingakuCurrentBefore from 'views/Analysis/AnalysisKingakuCurrentBefore';
import AnalysisKingakuBigSmall from 'views/Analysis/AnalysisKingakuBigSmall';

import { ComparisonKind } from 'views/Analysis/analysisUtils';

// 分析（契約単価）
function AnalysisKingaku(props) {
  // 分析情報
  const quoteList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 移動年計
  const mat = props.movingAnnualTotal?.kingaku ?? [];

  // 昨対比 or 工事／管・小
  return props.comparisonKind === ComparisonKind.CURRENT_BEFORE ? (
    <AnalysisKingakuCurrentBefore
      quoteList={quoteList}
      selectedPeriod={selectedPeriod}
      movingAnnualTotal={mat}
    ></AnalysisKingakuCurrentBefore>
  ) : (
    <AnalysisKingakuBigSmall
      quoteList={quoteList}
      selectedPeriod={selectedPeriod}
      movingAnnualTotal={mat}
    ></AnalysisKingakuBigSmall>
  );
}
export default AnalysisKingaku;
